import { FC, ReactNode } from 'react'

import { useQuery } from '@tanstack/react-query'
import { getRouteApi } from '@tanstack/react-router'
import { relationshipsReportQueryOptions } from '~bank-reports/service/relationshipsReportQueryOptions'
import { RelationshipsReportResponse } from '~bank-reports/types/RelationshipsReport'

import { RelationshipsReportContext } from './RelationshipsReportContext'

export const RelationshipsReportContextContextProvider: FC<{
  children: ReactNode
}> = ({ children }) => {
  const routeApi = getRouteApi('/_app/reports/relationships')
  const search = routeApi.useSearch()

  const { data, isFetching } = useQuery<RelationshipsReportResponse>(relationshipsReportQueryOptions(search))

  if (!data) return null

  return (
    <RelationshipsReportContext.Provider value={{ data, isFetching, routeApi }}>
      {children}
    </RelationshipsReportContext.Provider>
  )
}
